import React from "react";
import { motion } from "framer-motion";
import { FaBriefcase } from "react-icons/fa";
import SectionHeading from "../../components/SectionHeading";
import { homeIcons } from "../Home/homeIcons";
import { industriesContent } from "./isoContent";

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

/* The shared registry covers seven of the eight; "Service Organizations" is
   the one sector the Home page never listed, so it gets its glyph here rather
   than widening a registry the rest of the site shares. */
const icons = { ...homeIcons, service: FaBriefcase };

const IsoIndustries = () => (
  <section
    className="bg-white py-14 lg:py-20"
    aria-labelledby="iso-industries-heading"
  >
    <div className="brand-col">
      <SectionHeading
        id="iso-industries-heading"
        title={industriesContent.title}
        subtitle={industriesContent.intro}
        /* a lead-in sentence, not a sub-heading — the document gives this
           section none */
        subtitleAs="p"
        subtitleClassName="mx-auto max-w-2xl text-sm md:text-base leading-relaxed text-gray-600"
      />
      <motion.ul
        className="grid list-none grid-cols-1 gap-4 p-0 sm:grid-cols-2 lg:grid-cols-4"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ visible: { transition: { staggerChildren: 0.06 } } }}
      >
        {industriesContent.industries.map((industry) => {
          const Icon = icons[industry.icon];
          return (
            <motion.li
              key={industry.name}
              variants={itemVariants}
              className="brand-card brand-card-row gap-4 p-5"
            >
              <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-[var(--brand-primary)] text-white shadow-md">
                <Icon aria-hidden="true" className="h-5 w-5" />
              </span>
              <span className="text-sm md:text-base font-semibold text-gray-900">
                {industry.name}
              </span>
            </motion.li>
          );
        })}
      </motion.ul>
    </div>
  </section>
);

export default IsoIndustries;
